import title from './title.js';

export default dsf.component({
  name: 'DsfTitle3',
  mixins: [title],
  ctrlCaption: "三级标题",
  props: {
    value: {
      type: [String, Number],
      default: '标题3'
    },
    fontType: {
      type: Number,
      default: 3
    }
  }
});